import React, {
  useEffect,
  useState
} from 'react';

import { useParams } from 'react-router-dom';

import Diploma from './Diploma';

import './verifyCertificate.css';


const VerifyCertificate = () => {

  const { certificateCode } = useParams();

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);


  /* =========================
     VERIFICARE CERTIFICAT
  ========================= */

  useEffect(() => {

    if (!certificateCode) {

      setError(
        'Cod certificat invalid'
      );

      setLoading(false);

      return;
    }


    const verifyCertificate = async () => {

      try {

        setLoading(true);
        setError(null);


        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/verify/${certificateCode}`
        );


        const data =
          await response.json();


        /* =========================
           CERTIFICAT NEGASIT
        ========================= */

        if (response.status === 404) {

          setResult({
            valid: false,
            notFound: true
          });

          return;
        }


        /* =========================
           ALTA EROARE SERVER
        ========================= */

        if (!response.ok) {

          throw new Error(
            data?.error ||
            'Certificatul nu a putut fi verificat'
          );

        }


        /* =========================
           CERTIFICAT GASIT
        ========================= */

        setResult(data);


      } catch (error) {

        console.error(
          'Eroare verificare certificat:',
          error
        );


        setError(
          'Certificatul nu a putut fi verificat'
        );


      } finally {

        setLoading(false);

      }

    };


    verifyCertificate();

  }, [certificateCode]);


  /* =========================
     LOADING
  ========================= */

  if (loading) {

    return (

      <div className="verify-certificate-page">

        <div className="verify-loading">

          <div className="verify-loading-spinner" />

          <p>
            Se verifica certificatul...
          </p>

        </div>

      </div>

    );

  }


  /* =========================
     EROARE
  ========================= */

  if (error) {

    return (

      <div className="verify-certificate-page">

        <div className="verify-result-card verify-error">

          <div className="verify-result-icon">
            !
          </div>

          <h1>
            Eroare la verificare
          </h1>

          <p>
            {error}
          </p>

        </div>

      </div>

    );

  }


  /* =========================
     CERTIFICAT NEGASIT
  ========================= */

  if (result?.notFound) {

    return (

      <div className="verify-certificate-page">

        <div className="verify-result-card verify-invalid">

          <div className="verify-result-icon">
            ×
          </div>

          <h1>
            Certificat negasit
          </h1>

          <p>
            Codul introdus nu corespunde unui certificat
            emis de ContaLearn.
          </p>


          <div className="verify-code-box">

            <span>
              Cod verificat
            </span>

            <strong>
              {certificateCode}
            </strong>

          </div>

        </div>

      </div>

    );

  }


  const certificate =
    result?.certificate;


  /* =========================
     CERTIFICAT REVOCAT
  ========================= */

  if (!result?.valid) {

    return (

      <div className="verify-certificate-page">

        <div className="verify-result-card verify-revoked">

          <div className="verify-result-icon">
            !
          </div>

          <h1>
            Certificat revocat
          </h1>

          <p>
            Acest certificat a fost emis de ContaLearn,
            dar nu mai este activ.
          </p>


          <div className="verify-code-box">

            <span>
              Cod certificat
            </span>

            <strong>
              {certificate?.certificate_code}
            </strong>

          </div>

        </div>

      </div>

    );

  }


  /* =========================
     CERTIFICAT VALID
  ========================= */

  return (

    <div className="verify-certificate-page">


      {/* =========================
          STATUS VERIFICARE
      ========================= */}

      <div className="verify-success-header">

        <div className="verify-success-icon">
          ✓
        </div>


        <div className="verify-success-content">

          <h1>
            Certificat verificat
          </h1>

          <p>
            Acest certificat este valid si a fost emis de ContaLearn.
          </p>

        </div>

      </div>


      {/* =========================
          DIPLOMA ORIGINALA
      ========================= */}

      <div className="verify-certificate-diploma">

        <Diploma
          certificateData={certificate}
          publicView={true}
        />

      </div>


      {/* =========================
          DATE VERIFICARE
      ========================= */}

      <div className="verify-information">


        <div className="verify-information-item">

          <span>
            Cod certificat
          </span>

          <strong>
            {certificate.certificate_code}
          </strong>

        </div>


        <div className="verify-information-divider" />


        <div className="verify-information-item">

          <span>
            Status
          </span>

          <strong className="verify-valid-status">
            Valid
          </strong>

        </div>


        <div className="verify-information-divider" />


        <div className="verify-information-item">

          <span>
            Emitent
          </span>

          <strong>
            ContaLearn
          </strong>

        </div>


      </div>


    </div>

  );

};


export default VerifyCertificate;